import { SPINNER_LOADING } from './action-type';

export function spinnerLoading(payload) {
    return {
        type: SPINNER_LOADING,
        payload
    };
}
